import { defineStore } from 'pinia';
import Keycloak from 'keycloak-js';

export const useAuthStore = defineStore('authStore', {
  state: () => {
    return {
      keycloak: undefined as Keycloak | undefined,
    };
  },
});
